import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const StepsContainer = styled('div')`
  .steps {
    padding-right: 0;
    padding-left: 0;
  }
`;

export const StepContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: theme.palette.blue10.main,
}));

export const StepNumber = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  color: theme.palette.blue80.main,
}));
